
export const BOT_DIFFERENCE = 0.3;
